import Image from 'next/image';
import React from 'react';
import styled from 'styled-components';

interface TOUR {
  duration: number;
  mobile?: boolean;
  name: string;
}

const StyleDiv = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 1rem;
  @media (max-width: 650px) {
    margin-bottom: 10px;
    gap: 0.8rem;
  }
  @media (max-width: 450px) {
    margin-bottom: 10px;
    gap: 0.5rem;
  }
`;

const TourBasics = ({ duration, mobile, name }: TOUR) => {
  const durationInMinutes = duration;
  const durationInHours = durationInMinutes / 60;

  // Format to avoid unnecessary decimals
  const formattedDuration = Number.isInteger(durationInHours)
    ? durationInHours
    : durationInHours.toFixed(1);
  const showItems = [
    {
      icon: '/clock_icon.svg',
      text: `${formattedDuration}
            ${Number(formattedDuration) > 1 ? 'Hours' : 'Hour'}`,
      key: 'duration'
    },
    {
      icon: '/persons_icon.svg',
      text: `Up to 7 people`,
      key: 'people'
    },
    ...(!name?.includes('Walking') &&
    name !== 'Saint John Reversing Falls Rapids Thrill Ride Jetboat'
      ? [
          {
            icon: '/transport_icon.svg',
            text: 'Hotel Pick-up',
            key: 'pickup'
          }
        ]
      : [])
  ];

  return (
    <StyleDiv
      className={`
        ${mobile ? 'w-full' : 'w-[inherit]'} 
        flex justify-start gap-5 md:items-end items-center
      `}
    >
      {showItems.map((item, index) => (
        <div
          key={item.key}
          className={`
            flex gap-2 justify-start items-center 
            ${
              index < showItems.length - 1
                ? 'pr-1 md:pr-5 border-r-2 border-[#EEEE]'
                : ''
            }
          `}
        >
          <Image
            src={item.icon}
            width={20}
            height={20}
            alt={`${item.key}-icon`}
          />
          <span className="text-xs md:text-sm text-[#1A202C] font-normal">
            {item.text}
          </span>
        </div>
      ))}
    </StyleDiv>
  );
};

export default TourBasics;
